import {vsRangesLevels} from "../../_helper/vsRanges";
import {s_char_disciplines} from "../../_signals/s_char";

export const DisciplinesHighestLevel=()=> {
    const levels = vsRangesLevels
    const disciplines = s_char_disciplines.value;

    let highestCircle = 0;
    let highestLevel='common';
    disciplines.forEach((discipline) => {
        if (discipline.circle >= highestCircle) highestCircle = discipline.circle;
    })
    if (highestCircle >= 1) highestLevel = 'novice';
    if (highestCircle >= 4) highestLevel = 'journeyman';
    if (highestCircle >= 7) highestLevel = 'guardian';
    if (highestCircle >= 10) highestLevel = 'master';

    return highestLevel;
}